import React, { useEffect } from "react";
import "./ComingSoon.css";
import Footer from "../components/Footer"; // adjust as needed

const ComingSoon = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  return (
    <div className="coming-soon-container">
      <h1 className="coming-title">Coming Soon</h1>

      <section className="membership-section">
        <h2>Free Membership</h2>
        <ul>
          <li>Discord Access (Limited)</li>
          <li>Achievements</li>
          <li>Earn Experience and Levels (25% of baseline)</li>
        </ul>
      </section>

      <section className="membership-section">
        <h2>Basic Membership</h2>
        <ul>
          <li>Everything in Free Membership</li>
          <li>Discord Access with Bug Reporting</li>
          <li>Earn Experience and Levels (50% of baseline)</li>
          <li>Points Shop (Earn problem slots, UI flair, icons and more!)</li>
        </ul>
      </section>

      <section className="membership-section">
        <h2>Premium Membership</h2>
        <ul>
          <li>Everything in Basic Membership</li>
          <li>Earn Experience and Levels (100% of baseline)</li>
          <li>Monthly Discord Q&A</li>
          <li>Daily/Weekly and Monthly Coding Challenges</li>
          <li>Coding Leaderboards</li>
        </ul>
      </section>

      <section className="membership-section">
        <h2>Schools / Licensed Professionals</h2>
        <ul>
          <li>Everything in Premium Membership</li>
          <li>Tutor / Teacher / Coach Monitoring</li>
          <li>Track Student/Alumni Progress</li>
        </ul>
      </section>

      <Footer />
    </div>
  );
};

export default ComingSoon;
